import { scmsService } from "../services/site";
import { settings } from "../common/setting";
import { cr, URLS, ck } from "fire-wind-water";
import * as $ from "jquery";
import { user } from "../user/index";

class Email {
  constructor() {}
  currentFid = "";
  $user: any = {};
  downLoad(ev, type: string, o, id) {
    ev.preventDefault();
    if (parseInt(type, 10) === 1) {
      if (o.linkType === "custom") {
        $sk.goto(o.link);
      }
    } else {
      // 正式访问的链接改成了预览的链接，预览和正式要区分开
      if (settings.isPreview && URLS.getURL("preview")) {
        $sk.alert("当前为预览页面，不支持下载");
        return false;
      }
      this.getDownUrl(o, id);
    }
    return false;
  }

  catchError(res: any): void {
    if (res.result == 0) {
      $sk.confirm("您尚未登录，是否去登录？", {
        ok() {
          $sk.goto(
            URLS.updateSearchParam(
              "backUrl",
              encodeURIComponent(window.location.href),
              res.content.originUrl.wap
            )
          );
        },
      });
    } else {
      $sk.alert(res.desc);
    }
  }

  getDownUrl(o: { [label: string]: string }, id) {
    const s = $sk.template.get();
    this.$user.session = s.user.session;
    const m = {
      tenantId: settings.tenantId,
      siteId: settings.siteId,
      fileId: o.id,
      sess: this.$user.session || "",
      category: settings.category,
    };
    scmsService.getFileAuth(m).subscribe(
      (res) => {
        const d = parseInt(res.result, 10);
        if (res.content.isAuth === "has") {
          if (res.content.downloadType == 1) {
            // 判断是否为安卓微信环境
            const ua = navigator.userAgent.toLowerCase();
            const isWechatAndAndroid = ua.indexOf("micromessenger") !== -1 && ua.indexOf("android") !== -1;
            if (isWechatAndAndroid) {
              this.showWechatTip();
            } else {
              window.location.replace(
                res.content.fileUrl +
                  "&moduleType=36&sourceDownload=1&instanceId=" +
                  settings.instanceId
              );
            }
          } else {
            if (!ck.cookie("sendEmail")) {
              ck.cookie("sendEmail", res.content.sendEmail || "");
            }
            $(".error").html("");
            $("#down-email-" + id).val(ck.cookie("sendEmail") || "");
            this.currentFid = o.id;
            $("#down-box-" + id).show();
          }
        } else {
          this.catchError(res);
        }
      },
      (err) => {
        this.catchError(err);
      }
    );
  }
  send(e, id) {
    const email = $("#down-email-" + id).val();
    const filename = window.location.href.split("/").pop();
    const fid =
      URLS.getURL("fid") ||
      filename.slice(0, filename.lastIndexOf(".")).split("_")[2];
    const reg =
      /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    if (!reg.test(email)) {
      $(".error").html("请输入正确的邮箱");
      return;
    } else {
      $(".error").html("");
    }
    ck.cookie("sendEmail", $("#down-email-" + id).val());
    const param = {
      email: email,
      fileList: [this.currentFid],
      globalUserId: user.globalUserId,
      sess: this.$user.session || "",
      moduleType: 36,
      instanceId: settings.instanceId,
      tenantId: settings.tenantId,
    };
    scmsService.downloadWithEmail(param).subscribe((res) => {
      $("#down-box-" + id).hide();
      $("#down-email" + id).val("");
      $sk.alert("文件已发送至邮箱");
    });
  }
  hide() {
    $(".down-box").hide();
  }

  showWechatTip() {
    // 创建微信原生样式的提示框
    const tip = $(`
      <div style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.75);
        color: #fff;
        padding: 15px 20px;
        border-radius: 6px;
        font-size: 14px;
        z-index: 9999;
        max-width: 80%;
        text-align: center;
        line-height: 1.5;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      ">可在浏览器打开此网页来下载文件</div>
    `);
    $("body").append(tip);
    // 3秒后自动消失
    setTimeout(() => {
      tip.fadeOut(200, function() {
        $(this).remove();
      });
    }, 3000);
  }
}

export { Email };
